// extracted by mini-css-extract-plugin
module.exports = {"post-list-group-title":"PostListGroupTitle-module--post-list-group-title--2aoXm","postListGroupTitle":"PostListGroupTitle-module--post-list-group-title--2aoXm"};